export var ZoneType;
(function (ZoneType) {
    ZoneType["SET_NAME"] = "zone/set-name";
    ZoneType["SET_POINT"] = "zone/set-point";
})(ZoneType || (ZoneType = {}));
